// extracted by mini-css-extract-plugin
export default {"earningCard":"EarningCard_earningCard__1W6ZO"};